import { TopicModel } from "./models/TopicModel";

export const GrammarData: Record<string, TopicModel[]> = {
  "PRESENT TENSES": [
    new TopicModel("Presente", "present", "gradient1"),
    new TopicModel("Pretérito Perfecto", "present_perfect", "gradient2"),
  ],
  "PAST TENSES": [
    new TopicModel("Pretérito Indefinido", "past_simple", "gradient3"),
    new TopicModel("Pretérito Imperfecto", "past_progressive", "gradient4"),
    new TopicModel("Pretérito Pluscuamperfecto", "past_perfect", "gradient5"),
  ],
  "SUBJUNCTIVE & IMPERATIVE": [
    new TopicModel("Imperativo", "imperative", "gradient6"),
    new TopicModel("Subjuntivo", "subjunctive", "gradient1"),
  ],
  "FUTURE TENSES": [
    new TopicModel("Futuro Imperfecto", "simple_future", "gradient2"),
    new TopicModel("Futuro Perfecto", "future_perfect", "gradient3"),
  ],
  "PRONOUNS": [
    new TopicModel("Pronombres/Adjetivos Posesivos", "possessive", "gradient4"),
    new TopicModel("Pronombres de Objeto Directo / Indirecto", "pronouns", "gradient5"),
  ],
  "OTHER TOPICS": [
    new TopicModel("Condicional Simple", "conditional", "gradient6"),
    new TopicModel("Verbos Reflexivos", "reflexive", "gradient1"),
    new TopicModel("Voz Activa/Pasiva", "voz", "gradient2"),
  ],
};

export default GrammarData;
